import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';
import {
  productShape,
  type Product,
} from '../../../../utils/api/types/access-api-types';

export interface GetProductByAccessCodeParams {
  accessCode: string;
}

export async function getProductByAccessCodeApi(
  accessCode = ''
): Promise<Product> {
  const product = await fetcher<Product>(
    `/products/access-code/${accessCode}`,
    {
      service: '/fulfillment',
      version: '/v2',
    }
  );

  return productShape.parse(product);
}

export const getProductByAccessCodeApiQueryKey = (accessCode = '') =>
  ['/v2', 'fulfillment', 'products', 'access-code', accessCode].filter(Boolean);

export function useGetProductByAccessCodeApi(
  accessCode?: string,
  customQueryOptions?: Omit<
    UseQueryOptions<Product, ApiError<{ code: string; message: string }>>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<Product, ApiError<{ code: string; message: string }>> {
  return useQuery({
    queryKey: getProductByAccessCodeApiQueryKey(accessCode),
    queryFn: () => getProductByAccessCodeApi(accessCode),
    enabled: Boolean(accessCode),
    ...customQueryOptions,
  });
}
